import PropTypes from 'prop-types';
import { Component, Children } from 'react';

export class SubFormRouter extends Component {
    render() {
        const {
            location: {
                query: {
                    subformroute
                }
            }
        } = this.context;

        let element;
        Children.forEach(this.props.children, subRoute => {
            if(subRoute.props.query === subformroute) {
                element = subRoute;
            }
        });
        return element;
    }
}

export class SubFormRoute extends Component {
    render() {
        return Children.only(this.props.children);
    }
}

SubFormRouter.contextTypes = {
    router: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

SubFormRoute.propTypes = {
    query: PropTypes.string,
    children: PropTypes.element
};

export default SubFormRoute;
